import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { Target, FileText, MessageSquare, Users, Map } from "lucide-react";

const HowSection = () => {
  const { t } = useTranslation('home');

  const steps = [
    { icon: Target, titleKey: "how.steps.partner.title", descriptionKey: "how.steps.partner.description" },
    { icon: FileText, titleKey: "how.steps.define.title", descriptionKey: "how.steps.define.description" },
    { icon: MessageSquare, titleKey: "how.steps.communicate.title", descriptionKey: "how.steps.communicate.description" },
    { icon: Users, titleKey: "how.steps.longterm.title", descriptionKey: "how.steps.longterm.description" },
    { icon: Map, titleKey: "how.steps.local.title", descriptionKey: "how.steps.local.description" },
  ];

  return (
    <section id="how" className="py-32">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4 font-medium">
            How it works
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-5 text-balance">
            {t('how.title')}
          </h2>
          <p className="text-lg text-muted-foreground text-balance">
            {t('how.subtitle')}
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-3">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card
                key={index}
                className="group animate-fade-in"
                style={{ animationDelay: `${index * 80}ms` }}
              >
                <CardContent className="p-6 md:p-7">
                  <div className="flex flex-col md:flex-row gap-5 items-start">
                    <div className="flex items-center gap-4 md:w-44 flex-shrink-0">
                      <span className="text-xs font-mono text-muted-foreground tabular-nums">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <div className="w-10 h-10 rounded-xl bg-foreground/[0.04] border border-border/60 flex items-center justify-center">
                        <Icon className="w-4.5 h-4.5 text-foreground" aria-hidden="true" strokeWidth={1.75} />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg font-semibold mb-1.5 tracking-tight">{t(step.titleKey)}</h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {t(step.descriptionKey)}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowSection;
